import { z } from 'zod';

const UpdateAlertNotificationConfigurationInputSchema = z.object({
  deviceId: z.string(),
  userId: z.number().int(),
  notifyEmail: z.boolean().optional(),
  notifySms: z.boolean().optional(),
  notifyWhatsapp: z.boolean().optional(),
  notifyPush: z.boolean().optional(),
});

export const UpdateAlertNotificationConfigurationsSchema = z.object({
  input: z.array(UpdateAlertNotificationConfigurationInputSchema),
});

export type FormValues = z.infer<typeof UpdateAlertNotificationConfigurationsSchema>;
